// Invoice Fields
export const DOCUMENT_TYPE = "documentTypeId";
export const HEADER = "header";
export const LINE_ITEM = "lineItems";

export const VENDOR_ID = "vendorId";
export const PAYMENT_TERM_ID = "paymentTermId";
export const BILLING_CATEGORY = "billingCategory";
export const ZONE_ID = "zoneId";
export const BLOCK_ID = "blockId";
export const PROPERTY_ID = "propertyId";
export const PROPERTY_OWNERSHIP_ID = "propertyOwnershipId";
export const GL_MASTER = "glMasterId";
export const ALT_GL_MASTER = "alternativeAccount";
export const BANK_ACC_GL = "bankAccountGlId";
export const BANK_ACC_NAME = "bankAccountName";
export const TRANSACTION_TYPE = "transactionType";
export const DRCR = "drCr";
export const LINE_ITEM_TYPE = "lineItemType";
export const BUDGET_YEAR = "budgetYear";
export const BUDGET_START_MONTH = "budgetMonthStart";
export const BUDGET_END_MONTH = "budgetMonthEnd";
export const BALANCE_AMOUNT = "balanceAmount";
export const POSTING_DATE = "postingDate";
export const POSTING_YEAR = "postingYear";
export const POSTING_PERIOD = "postingPeriod";
export const DUE_DATE = "dueDate";
export const UNITS = "numberOfUnits";
export const RATE = "ratePerUnit";
export const AMOUNT = "amount";
export const CURRENCY = "invoiceCurrency";

export const DIST_ZONE = 'distZoneId';
export const DIST_BLOCK = 'distBlockId';
export const DIST_PROPERTY = 'distPropertyId';

export const HEADER_PAYLOAD = "headerPayload";
export const LINE_ITEM_PAYLOAD = "lineItemsPayload";

export const skippedFields = [BUDGET_END_MONTH, BUDGET_START_MONTH, BALANCE_AMOUNT];

export const isFieldSkipped = (fieldName: string) => {
  return skippedFields.includes(fieldName)
}

export const auditStage: any = {
  submission: "SUBMISSION",
  validation: "FIELD_VALIDATION",
  business_rules: "BUSINESS_RULES",
  park: "PARK",
  post: "POST",
}